<template>
  <el-dialog :title="title" :visible.sync="visible" width="40%" @closed="closed" :closeOnClickModal="false">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="企业名称:" prop="tenantFullName">
        <el-input
          type="text"
          :maxlength="30"
          v-model="data.tenantFullName"
          placeholder="请输入30字以内名称"
          clearable
        >
          <el-button slot="append" @click.stop="checkJoin">检查是否入驻</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="LOGO:" prop="companyLogo">
        <FileUploadHeader
            v-model="fileObjs"
            :limit="1"
            :readOnly="false"
              accept="image/gif,image/jpg,image/jpeg,image/png"
              :fixedNumber="[21, 21]"
              :autoCropWidth="210" :autoCropHeight="210"
            @on-change="handleFileChange"
          ></FileUploadHeader>
      </el-form-item>
      <el-form-item label="联系人:">
        <el-input
          type="text"
          :maxlength="6"
          v-model="data.linkNickName"
          placeholder="请输入6字以内名称"
          clearable
        />
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input
          type="text"
          :maxlength="30"
          v-model="data.linkTel"
          placeholder="请输入联系人手机号"
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { listAllLevelArea } from "@/api/crm/area";
import {isPhone} from "@/utils/validate";
import { saveMember, checkByName } from "@/api/system/tenant";
import { transferCascaderOptionsForProvince } from "@/utils";
import FileUploadHeader from "@/components/CropperFileUpload/CropperFileUpload";

export default {
  name: "AddMemberDialog",
  components: {
    FileUploadHeader
  },
  props: {},
  data() {
    return {
      visible: false,
      title: '',
      areaOptions: [],
      rules: {
        tenantFullName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "change"
          }
        ],
        linkNickName: [
          { required: true, message: "请输入联系人", trigger: "change" }
        ],
        linkTel: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: this.checkMobile, trigger: "blur" }
        ]
      },
      fileObjs: [],
      data: {
        tenantFullName: null,
        linkNickName: null,
        linkTel: null,
        companyLogo: null,
      }
    };
  },
  created() {
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        this.data.companyId = null;
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (row, type) {
      this.visible = true
      this.resetFormData()
      if(row){
        this.title = '编辑成员'
        this.data = row
        if(row.companyLogo != ''){
          this.fileObjs = [{
            isImg: true,
            url: this.data.companyLogo
          }]
        }else {
          this.fileObjs = []
        }
      }else {
        this.title = '新增成员'
      }

    },
    resetFormData () {
      this.fileObjs = []
      this.resetForm("addForm");
      this.data.id = null
      this.data.tenantFullName = null
      this.data.linkNickName = null
      this.data.linkTel = null
      this.data.companyLogo = null
    },
    checkMobile (rule, value, callback) {
      // 非必填
      if (!value) {
        callback()
      } else if (isPhone(value)) {
        // 填了客户名称，才去校验手机号。所以需要在填写客户名称后再手动触发下手机号校验
        callback()
      } else {
        callback(new Error('请输入正确格式'))
      }
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          saveMember(this.data)
            .then(response => {
              this.$emit("success");
              this.visible = false;
              loading.close();
              this.msgSuccess(this.data.id ? '编辑成功':'添加成功' );
            })
            .catch(error => {
              loading.close();
            });
        } else {
          // this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    handleFileChange(fileObjs) {
      this.fileObjs = fileObjs
      if(fileObjs.length) {
        fileObjs.map(item => {
          this.data.companyLogo = item.url
        })
      }else {
        this.data.companyLogo = ''
      }
    },
    checkJoin() {
      console.log('check')
      if(!this.data.tenantFullName) {
        this.msgError('请输入企业名称！')
        return
      }
      checkByName({
        fullName: this.data.tenantFullName
      })
        .then(response => {
          console.log('ceshi', response)
          let list = response.data
          if(list.length>0){
            this.msgInfo('该企业已入驻平台')
          }else {
            this.msgInfo('抱歉，该企业暂未入驻平台')
          }
        })
        .catch(error => {
          loading.close();
        });
    },
    closed(){
      this.fileObjs = []
    }
  }
};
</script>
